import { useEffect } from 'react';

const useScript = (url, onLoad) => {
  useEffect(() => {
    if(!url) return;
    const script = document.createElement('script');

    script.src = url;
    script.async = true;
    script.onload = onLoad;

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);
};

export default useScript;
